import { FilterOptionSchema } from "../components/Filter/filter.data";

export interface IWorkFlowRequestInfo {
  name: string;
  workflow_id: number;
  form_id: number;
}

export interface IRequestStageDetail {
  id: number;
  title: string;
  team: string;
  status: string;
  description: string;
  sla: string;
  requestor: string;
  requestor_team: string;
  assignees: FilterOptionSchema[];
  followers: FilterOptionSchema[];
  assigned_date: string;
  due_date: string;
  completed_date: string;
  notes: string;
  tasks: { id: number; name: string; active: string }[];
  comment: string;
  next_stages: FilterOptionSchema[];
}

export interface IWorkFlowRequestStage {
  title: string;
  description: string;
  team: {
    id: number;
    name: string;
  };
  sla: number;
  id: number;
  stage_id: number;
  status: string;
  active_days: string;
  due_date: string;
}

export enum WORKFLOW_REQUEST_STAGE_STATUS {
  IN_PROGRESS = "In Progress",
  YET_TO_START = "Yet To Start",
  COMPLETED = "Completed",
  ON_HOLD = "On Hold",
}
